var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-download-brochure-modal"},[_c('MoleculesProjectMoleculeDownloadBrochure'),_vm._v(" "),_c('MoleculesProjectMoleculeSendRequest',{ref:"successMessageBrochure"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }